import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminRoleService } from '../service/admin-role.service';
import { UtilService } from '../service/util.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { Constants } from '../constants/constants';
import { ToastService } from '../service/toast.service';
import { NgForm, NgModel } from '@angular/forms';
import { RolePipe } from '../pipe/role.pipe';
import { EnvService } from '../service/env.service';
import { Observable } from 'rxjs/internal/Observable';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { map } from 'rxjs/internal/operators/map';
import { SearchDataService } from '../service/search-data.service';
import { IntlPhoneInputComponent } from '../intl-phone-input/intl-phone-input.component';
import { PhoneValidatorDirective } from '../directives/phone-validator.directive';
import { PhoneFormatterDirective } from '../directives/phone-formatter.directive';
// import { SearchCountryField, PhoneNumberFormat, CountryISO } from 'ngx-intl-tel-input';
// import { NgxIntlTelInputService } from '../service/ngx-intl-tel-input-service.service';
// import { PhoneNumberFormat } from 'google-libphonenumber';

@Component({
  selector: 'app-admin-detail',
  templateUrl: './admin-detail.component.html',
  styleUrls: ['./admin-detail.component.scss']
})
export class AdminDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  adminId: string;
  admin: any = null;
  userRoles: Array<any> = [];
  status: Array<string> = ["INACTIVE", "PENDING", "ACTIVE", "DISABLED"];
  adminStatus: string = this.status[2];
  adminList: any = [];
  accountCategory: string;
  accountType: string;
  loggedInUserId: any;
  @ViewChild('updateRoleForm', { static: true }) public updateRoleForm: NgForm;
  updateRoleModal = null;
  rolePipe: RolePipe = new RolePipe();
  authSubscription: any;
  isSelfAccount = false;
  isAllowUpdate = false;
  @ViewChild('updateUserForm') public updateUserForm: NgForm;
  // @ViewChild('IntlPhoneInputComponent') intlPhoneInputComponent!: IntlPhoneInputComponent;
  
  updateUserModal: any = {};
  // isd = "";
  // countryList: any[];
  selectedIsdDetails: any;
  /* isdFormatter = (x: { isd: string }) => x.isd;
  searchIsd = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? [] : this.countryList.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1 || v.isd.toLowerCase().indexOf(term.toLowerCase()) > -1)))
    );
  phoneLength = 0; */
  account: any;
  // SearchCountryField = SearchCountryField;
  // PhoneNumberFormat = PhoneNumberFormat;
  // selectedCountryISO: any;
  // selectedPhone: any;
	// preferredCountries: CountryISO[] = Constants.PREFERRED_COUNTRIES;
  intlTelInputConfigData: any;
  phoneNumber: any;

  // countries = Constants.COUNTRIES;
  // selectedCountryIsd: string = null;
  // selectedUserPhone: string = null;
  adminPhone: string = null;
  adminCountryIsotwo: any;
  allCountryList: any[];

  @ViewChild(PhoneValidatorDirective) phoneValidator!: PhoneValidatorDirective;
  @ViewChild(PhoneFormatterDirective) phoneFormatter!: PhoneFormatterDirective;
  @ViewChild('phoneElement', { static: true, read: ElementRef }) phoneInput!: ElementRef;
  
  constructor(
    private adminRoleService: AdminRoleService,
    private apiService: ApiService,
    public authService: AuthenticationService,
    public utilService: UtilService,
    private toast: ToastService,
    private env: EnvService,
    private searchService: SearchDataService,
    private router: Router,
    // private ngxIntlTelInputService: NgxIntlTelInputService
  ) {

    this.authSubscription = this.authService.authenticationState.subscribe(state => {
      console.log("Auth Changed : ", state, " logged in user details : ", this.authService.loggedInUser);
    });
    // this.countryList = this.getCountryList(this.env.REGION);
  }

  ngOnInit() {
    this.allCountryList = this.utilService.getCountryList();

    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.account = this.authService.accountData;

    this.admin = this.utilService.selectedAccountUser;
    this.adminStatus = (this.admin && this.admin.status) ? this.admin.status : this.status[2];
    console.log("admin :: ", this.admin, " -- logged in user : ", this.authService.loggedInUser);
    this.loggedInUserId = this.authService.loggedInUser.userId;
    this.initUpdateRoleModal();
    this.setIsSelfAccount();
    this.userRoles = this.adminRoleService.adminRoles;

    console.log("authService.accountData.isShowDeveloperUser: ", this.authService.accountData.isShowDeveloperUser);
    console.log("this.adminRoleService.adminRoles: ", this.adminRoleService.adminRoles);
    if (!this.authService.accountData.isShowDeveloperUser) {
      var index = this.userRoles.indexOf('ROLE_ACCOUNT_DEVELOPER');
      if (index !== -1) {
        this.userRoles.splice(index, 1);
      }
    }

    this.isAllowUpdate = this.authService.isAdmin() && !this.isSelfAccount;
    
  }
  
  ngAfterViewInit(): void {
    /* this.intlTelInputConfigData = {
      initialCountry: 'us',
      separateDialCode: true,
      allowDropdown: true,
      countrySearch: true,
      preferredCountries: Constants.PREFERRED_COUNTRIES,
      utilsScript: 'assets/utils.js'
    };
  
    this.intlPhoneInputComponent.setIntlTelInputConfigData(this.intlTelInputConfigData); */
  }

  setIsSelfAccount() {
    if (this.admin.id == this.authService.loggedInUser.userId) {
      this.isSelfAccount = true;
    }
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  getAllUsers() {
    this.utilService.showSpinner();
    this.apiService.getAllUsers().then((data) => {
      this.utilService.hideSpinner();
      this.adminList = data;
      console.log("admin List ::", this.adminList);
      this.admin = this.adminList.find(e => e.id === this.adminId);
      this.adminStatus = (this.admin && this.admin.status) ? this.admin.status : this.status[2];
      console.log("Selected admin::", this.admin);

    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAllUsers();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  isRoleAccountAdmin() {
    var flag = false;
    for (var i = 0; i < this.admin.roles.length; i++) {
      if (this.admin.roles[i] == 'ROLE_ACCOUNT_ADMIN') {
        flag = true;
        break;
      }
    }
    return flag;
  }

  onLocationManagementSelectionChange() {

  }

  onBrandTypeManagementSelectionChange() {

  }

  onDeveloperSelectionChange() {

  }

  currentConfirmation = {
    heading: null,
    content: null
  }

  onUserDeactivate() {
    this.currentConfirmation.heading = "Deactivate User";
    this.currentConfirmation.content = "Confirm deactivating " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onUserActivate() {
    console.log("Activating user : ", this.admin.id);
    this.currentConfirmation.heading = "Activate User";
    this.currentConfirmation.content = "Confirm activating " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
    // this.activateUser(this.admin.id);
  }

  onResetPassword() {
    this.currentConfirmation.heading = "Reset Password";
    this.currentConfirmation.content = "Confirm reset password for " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  onInviteResend() {
    this.currentConfirmation.heading = "Resend Invite";
    this.currentConfirmation.content = "Confirm resend invite to " + this.admin.name + " ?";
    document.getElementById("openConfirmationModel").click();
  }

  confirm() {

    if (this.currentConfirmation.heading == "Deactivate User") {
      // Handle user deactivate
      console.log("Deactivating user : ", this.admin.id);
      this.deactivateUser(this.admin.id);
    } else if (this.currentConfirmation.heading == "Reset Password") {
      // Handle user password reset
      console.log("Reset user : ", this.admin.username);
      this.resetUserPassword(this.admin.id);
    } else if (this.currentConfirmation.heading == "Update Role") {
      document.getElementById("closeConfirmationModel").click();
      this.roleUpdateConfirmed();
    } else if (this.currentConfirmation.heading == "Resend Invite") {
      document.getElementById("closeConfirmationModel").click();
      this.resendInvite(this.admin.id);
    } else if (this.currentConfirmation.heading == "Activate User") {
      document.getElementById("closeConfirmationModel").click();
      this.activateUser(this.admin.id);
    }

  }

  deactivateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deactivateAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User deactivated successfully");
      this.adminStatus = this.status[3];
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deactivateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  activateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.activateAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.adminStatus = this.status[2];
      this.toast.showSuccess("User activated successfully");
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.activateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetUserPassword(userId) {
    this.utilService.showSpinner();
    this.apiService.resetAccountUserPassword(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.message);
      // this.adminStatus = this.status[3];
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.resetUserPassword(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resendInvite(userId) {
    this.utilService.showSpinner();
    this.apiService.resendUserInvite(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.message);
      document.getElementById("closeConfirmationModel").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.activateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  initUpdateRoleModal() {
    this.updateRoleModal = {
      roles: new Array(),
      fleetDemoAppRole: null
    }

    if (this.admin && this.admin.roles) {
      for (var i = 0; i < this.admin.roles.length; i++) {
        var role = this.admin.roles[i];
        if (this.rolePipe.isFleetDemoAppRole(role)) {
          this.updateRoleModal.fleetDemoAppRole = role;
        } else {
          this.updateRoleModal.roles.push(role);
        }
      }
    }

    console.log("init update role modal value : ", this.updateRoleModal);
  }

  openUpdateRole() {
    document.getElementById("openUpdateRole").click();
  }

  updateRoleFormSubmit(form: NgForm) {
    this.updateRoleForm = form;
    console.log("Form submit");

    var payload = this.getUpdateRolePayload();

    if (payload.length > 0) {
      this.currentConfirmation.heading = "Update Role";
      this.currentConfirmation.content = " Confirm updating roles for "+ this.admin.name + " ?";
      document.getElementById("openConfirmationModel").click();
    } else {
      this.toast.showWarning("Select atleast 1 role");
    }
  }

  getUpdateRolePayload() {
    var payload = new Array();
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      payload.push(this.updateRoleModal.roles[i]);
    }

    if (this.updateRoleModal.fleetDemoAppRole)
      payload.push(this.updateRoleModal.fleetDemoAppRole);

    return payload;
  }

  roleUpdateConfirmed() {
    console.log("Role update confirmed api calling : ", this.updateRoleModal);

    var payload = this.getUpdateRolePayload();

    console.log("final payload : ", payload);
    this.utilService.showSpinner();
    this.apiService.updateUserRole(payload, this.admin.id).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User role updated successfully");
      document.getElementById("closeUpdateRole").click();
      this.admin.roles = JSON.parse(JSON.stringify(payload));
      this.resetUpdateRoleForm();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.roleUpdateConfirmed();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetUpdateRoleForm() {
    if (this.updateRoleForm) {
      this.updateRoleForm.reset();
      this.updateRoleForm.resetForm();
    }
    this.initUpdateRoleModal();
  }

  fleetDemoAppRoleClicked(key) {
    this.updateRoleModal.fleetDemoAppRole = key;
  }

  roleSelected(roleKey) {
    this.updateRoleModal.roles = [roleKey];
    //Old
    /*var isPresent = false;
    var presentIndex = 0;
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      if (roleKey == this.updateRoleModal.roles[i]) {
        isPresent = true;
        presentIndex = i;
        break;
      }
    }
    if (isPresent) {
      this.updateRoleModal.roles.splice(presentIndex, 1);
    } else {
      this.updateRoleModal.roles.push(roleKey);
    }*/

    console.log("final selected list : ", this.updateRoleModal.roles);
  }

  isRolePresent(role) {
    var flag = false;
    for (var i = 0; i < this.updateRoleModal.roles.length; i++) {
      if (role == this.updateRoleModal.roles[i]) {
        flag = true;
        break;
      }
    }
    return flag;
  }

  openUpdate() {
    console.log("Update button clicked isAllowUpdate : ", this.isAllowUpdate);
    this.initUpdateUserModal();
    document.getElementById("openUpdateProfile").click();
  }

  initUpdateUserModal() {
    this.updateUserModal = null;

    /* var userPhone = null;
    if (this.admin.phone) {
      var isdPhone = this.utilService.splitIsdAndPhone(this.admin.phone);
      userPhone = isdPhone.phone;
    } */
    
    this.updateUserModal = {
      name: this.admin.name,
      phone: this.utilService.checkPhoneWithIsd(this.admin.phone),
      isd: this.admin.isd ? this.admin.isd : Constants.DEFAULT_LOCALES[0].isd,
      country: this.admin.country ? this.admin.country : Constants.DEFAULT_LOCALES[0].country,
    };

    // this.selectedCountryIsd = this.admin.isd ? this.admin.isd : Constants.DEFAULT_LOCALES[0].isd;
    // this.selectedUserPhone = this.utilService.checkPhoneWithIsd(this.admin.phone);
    
    let adminCountryIsd = this.admin.isd ? this.admin.isd : Constants.DEFAULT_LOCALES[0].isd;
    this.adminCountryIsotwo = this.allCountryList.find(country => country.isd === adminCountryIsd).isotwo;
    this.adminPhone = this.utilService.checkPhoneWithIsd(this.admin.phone);
    this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo);

    // this.intlPhoneInputComponent.setPhoneNumber(this.updateUserModal.phone);
    // this.phoneNumber = JSON.parse(JSON.stringify(this.updateUserModal.phone));

    // this.initDefaultCountry();
    /* this.selectedPhone = {
		  "number": this.updateUserModal.phone,
		  // "countryCode": this.ngxIntlTelInputService.getCountryISO(this.updateUserModal.country)
		  "countryCode": this.countryCode(this.admin.isd)
		};  */
    // this.selectedPhone = this.admin.isd + this.updateUserModal.phone;

    // this.selectedCountryIsd = this.updateUserModal.isd;
    // this.selectedUserPhone = this.updateUserModal.phone;
    console.log("init updateUserModal :: ", this.updateUserModal);
  }

  updateUserFormSubmit(form: NgForm) {
    this.updateUserForm = form;
    if (!form.valid) return;

    /* let isPhoneFieldInvalid: boolean = (this.intlPhoneInputComponent.phoneModel.errors && this.intlPhoneInputComponent.phoneModel.errors.required) || !this.intlPhoneInputComponent.isValidNumber();
    
    if (isPhoneFieldInvalid) {
      return;
    } */

    // this.updateUserModal.phone = this.selectedPhone && this.ngxIntlTelInputService.removeNonNumeric(this.selectedPhone.number) || null;
    
    // this.updateUserModal.isd = this.selectedCountryIsd;
    // this.updateUserModal.phone = this.selectedUserPhone;

    this.updateUserModal.isd = this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo).isd;
    this.updateUserModal.phone = this.adminPhone.replace(/\D/g, '');

    console.log("update user modal::", this.updateUserModal);

    var payload = this.getUpdateUserModalPayload();
    console.log("payload::", payload);

    this.utilService.showSpinner();
    this.apiService.updateUserProfile(payload, this.admin.id).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.message);
      this.admin.phone = payload.phone;
      this.admin.name = payload.name;
      this.admin.isd = payload.isd;
      document.getElementById("closeUpdateProfile").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateUserFormSubmit(form);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getUpdateUserModalPayload() {
    let payload = JSON.parse(JSON.stringify(this.updateUserModal));

    if (![null, ""].includes(payload.phone)) {
      payload.phone = payload.phone;
      payload.isd = payload.isd;
    }
    delete payload.country;  

    return payload;
  }

  resetUserUpdateForm() {
    if (this.updateUserForm) {
      this.updateUserForm.reset();
      this.updateUserForm.resetForm();
      setTimeout(() => {
        this.initUpdateUserModal();
      }, 500);
    }
  }

  getCountryList(region): any[] {
    return this.utilService.getCountryList(region).sort(function (a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
  }

  /* countrySelected(country) {
    // this.selectedIsdDetails = this.countryList.filter(countryObject => countryObject.name == country)[0];
    // this.isd = this.selectedIsdDetails ? this.selectedIsdDetails.isd : null;
    this.updateUserModal.country = country ? country : null;
  }

  onIsdSelected(event) {
    this.isd = event.item.isd;
    this.phoneLength = event.item.phoneLength;
  } */

  /* initDefaultCountry() {
    this.updateUserModal.country = this.admin.country ? this.admin.country : null;

    // shu: remove below hardcoding
    let isd = this.admin.isd;
    
    this.selectedIsdDetails = isd ? this.countryList.filter(country => country.isd == isd)[0] : null;
    this.isd = this.selectedIsdDetails ? this.selectedIsdDetails.isd : null;
    this.phoneLength = this.selectedIsdDetails ? this.selectedIsdDetails.phoneLength : 0;
  } */

  navSearchClicked() {
    if (this.utilService.isOpenFromSearch) {
      console.log("Nav search clicked: ", this.searchService.searchKey);
      this.utilService.isSearchFromUserList = true;
      this.navigateToList();
    }
  }

  navigateToList() {
    this.router.navigate(["/admin-roles"]);
  }

  /* onCountryChange(event: any) {
    // this.updateUserModal.country = this.ngxIntlTelInputService.getCountryName(event.name);
    this.updateUserModal.isd = "+" + event.dialCode;
  }	 */
  
  countryCode(isd: string) {
    if (!isd) {
      console.log("ISD not set. Setting it to default");
      isd = Constants.DEFAULT_LOCALES[0].isd;
    }
    let countryCode;
    // let countryData = this.ngxIntlTelInputService.filterCountriesByIsd(isd);
    // if (countryData && countryData.length > 1) {
    //   countryCode = countryData[1];
    // }
    return countryCode;
  }  

  /* getPhoneData(event: any) {
  } */

  countryUpdated(event: any) {
    this.triggerPhoneInputChange(this.adminPhone, event);
  }

  triggerPhoneInputChange(phone: string, isotwo: string) {
    this.phoneValidator.countryCode = isotwo;
    this.phoneFormatter.countryCode = isotwo;
    this.phoneInput.nativeElement.value = phone;
    const event = new Event('input', { bubbles: true });
    this.phoneInput.nativeElement.dispatchEvent(event);
  }

  getAdminCountryIsd() {
    let adminCountryData = this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo);
    return adminCountryData ? adminCountryData.isd : null;
  }
}
